import React, { useState, useEffect } from "react";
import { Select } from "@windmill/react-ui";
import VehicleCategoryServices from "services/VehicleCategoryServices";

const SelectVehicleType = ({
  register,
  name,
  label,
  selectedVehicle,
  selectedOptions,
  ...props
}) => {
  const [allVehicleCategory, setVehicleCategory] = useState([]);
  useEffect(() => {
    async function fetchVehicleCategory() {
      try {
        const response = await VehicleCategoryServices.getAllVehicleCategory();
        setVehicleCategory(response.data); // Assuming the API response contains an array of profiles
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    }

    fetchVehicleCategory();
  }, []);

  return (
    <Select
      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      name={name}
      {...register(name, {
        required: `${label} is required!`,
      })}
      {...props}
    >
      <option value="">Select Vehicle</option>
      {Array.isArray(allVehicleCategory) && allVehicleCategory.length > 0 ? (
        allVehicleCategory.map((category) => (
          <option
            key={category.id}
            value={category.id}
            disabled={selectedOptions?.includes(String(category.id))}
          >
            {category["vehicle_type_name"]}
          </option>
        ))
      ) : (
        <option>Loading...</option>
      )}
    </Select>
  );
};

export default SelectVehicleType;
